import * as yup from 'yup';

const schema = () =>
  yup.object().shape({
    name: yup
      .string()
      .test('validate name', 'Please enter a full name', (value) => {
        return /^[^ ]+( [^ ]+)+$/.test(value.trim());
      })
      .required('Please enter a full name'),
    email: yup.string().email().required('Please enter a valid email'),
    password: yup.string().min(6, 'Minimum password is 6 character').nullable(),
    passwordConfirmation: yup
      .string()
      .test('passwords-match', 'Passwords must match', function (value) {
        return this.parent.password === value;
      }),
  });

export default schema;
